<template>
  <div id="App">
    <core-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
  }
}
</script>

<style lang="scss">
@import '@/styles/index.scss';

#virtual-scroll-table .v-table__overflow {
  width: 100%;
  overflow-x: auto;
  overflow-y: scroll;
  max-height: 700px;
}
#virtual-scroll-table .theme--light.v-table tbody tr:hover td,
#virtual-scroll-table .theme--light.v-table tbody tr[active],
#virtual-scroll-table .theme--light.v-table tbody tr[active] td {
  background-color: #41B3DF !important;
}
/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}

</style>
